import React from 'react';

import { LinksBlock } from 'src/components/molecules/LinksBlock';
import { LinksBlockGroup } from 'src/components/molecules/LinksBlock/LinksBlockGroup';
import { LinkGroup } from 'src/components/molecules/LinksBlock/types';
import { TrackingContext } from 'src/types/TrackingContext';
import { trackImpression } from '../../../tracking/common/trackImpression';
import { SectionContainer } from '../../molecules/SectionContainer';
import * as styles from './LinksBlockSection.style';

export interface LinksBlockSectionProps {
  title: string;
  subHeading: string;
  imageUrl: string;
  imageAlt: string;
  backgroundColor: string;
  linkGroups: LinkGroup[];
  trackingTitle: string;
  trackingPosition?: number;
}

export const LinksBlockSection = ({
  title,
  subHeading,
  imageUrl,
  imageAlt,
  backgroundColor,
  linkGroups,
  trackingPosition,
  trackingTitle,
}: LinksBlockSectionProps) => {
  const trackingContext: TrackingContext = {
    trackingPosition,
    trackingTitle,
    trackingContentType: 'Links block',
  };

  return (
    <SectionContainer wrapperStyles={styles.wrapper} maxWidth="full">
      <LinksBlock
        title={title}
        subHeading={subHeading}
        imageUrl={imageUrl}
        imageAlt={imageAlt}
        onVisible={() => trackImpression(trackingContext)}
        backgroundColor={backgroundColor}
      >
        {linkGroups.map(({ links, title }, index) => (
          <LinksBlockGroup key={title} title={title} links={links} open={index === 0} />
        ))}
      </LinksBlock>
    </SectionContainer>
  );
};
